import React from 'react';
import image2 from '../assets/images/image2.png';
import image3 from '../assets/images/image3.png';
import image4 from '../assets/images/image4.png';
import image7 from '../assets/images/image7.png';
import image8 from '../assets/images/image8.png';
import image9 from '../assets/images/image9.png';
import image10 from '../assets/images/image10.png';

const Services: React.FC = () => {
  return (
    <div className="services">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Dịch vụ của chúng tôi</h1>
          <p>Cung cấp đầy đủ các dịch vụ về gỗ nguyên liệu chất lượng cao</p>
        </div>
      </section>

      {/* Main Services */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Dịch vụ chính</h2>
            <p>Chúng tôi cung cấp đầy đủ các dịch vụ về gỗ nguyên liệu</p>
          </div>
          

          {/* Service 1: Wood Processing */}
          <div className="grid grid-2" style={{ alignItems: 'center', marginBottom: '4rem' }}>
            <div className="card text-center">
              <img src={image7} alt="Cưa xẻ gỗ gia công" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Cưa xẻ gia công</h4>
              <p>Độ chính xác cao, kinh nghiệm 15+ năm</p>
            </div>
            <div>
              <h3>1. Nhận cưa xẻ gỗ gia công theo quy cách</h3>
              <p style={{ marginBottom: '1.5rem' }}>
                Nhận cưa xẻ gỗ gia công theo quy cách với độ chính xác cao với kinh nghiệm hơn 15 năm.
              </p>
              
              <h4>Ưu điểm:</h4>
              <ul style={{ marginLeft: '1.5rem' }}>
                <li>Độ chính xác cao theo yêu cầu</li>
                <li>Kinh nghiệm 15+ năm trong nghề</li>
                <li>Thiết bị hiện đại và chuyên nghiệp</li>
                <li>Giao hàng đúng hẹn</li>
              </ul>
            </div>
          </div>

          {/* Service 2: Transportation Service */}
          <div className="grid grid-2" style={{ alignItems: 'center', marginBottom: '4rem' }}>
            <div>
              <h3>2. Xe cẩu: Dịch vụ vận chuyển</h3>
              <p style={{ marginBottom: '1.5rem' }}>
                Dịch vụ cẩu gỗ, thiết bị nặng trọng tải chuyển nhà xưởng lớn với tài xế 10 năm kinh nghiệm trong ngành.
              </p>
              
              <h4>Dịch vụ bao gồm:</h4>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '2rem' }}>
                <li>Cẩu gỗ và thiết bị nặng</li>
                <li>Vận chuyển nhà xưởng lớn</li>
                <li>Tài xế 10 năm kinh nghiệm</li>
                <li>Đảm bảo an toàn tuyệt đối</li>
              </ul>

              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '1rem',
                marginTop: '1rem'
              }}>
                <div className="card text-center">
                  <img src={image8} alt="Dịch vụ xe cẩu" style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '5px', marginBottom: '0.5rem' }} />
                  <h5 style={{ fontSize: '0.9rem', margin: '0' }}>Xe cẩu chuyên nghiệp</h5>
                </div>
                <div className="card text-center">
                  <img src={image9} alt="Vận chuyển thiết bị" style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '5px', marginBottom: '0.5rem' }} />
                  <h5 style={{ fontSize: '0.9rem', margin: '0' }}>Thiết bị nặng</h5>
                </div>
                <div className="card text-center">
                  <img src={image10} alt="Vận chuyển nhà xưởng" style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '5px', marginBottom: '0.5rem' }} />
                  <h5 style={{ fontSize: '0.9rem', margin: '0' }}>Nhà xưởng lớn</h5>
                </div>
              </div>
            </div>
            <div className="card text-center">
              <img src={image8} alt="Dịch vụ xe cẩu" style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Dịch vụ xe cẩu</h4>
              <p>Chuyên nghiệp, an toàn, uy tín</p>
              <div style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'var(--text-light)' }}>
                <strong>Kinh nghiệm:</strong> 10+ năm<br />
                <strong>An toàn:</strong> Tuyệt đối
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="section bg-light">
        <div className="container">
          <div className="section-title">
            <h2>Danh mục sản phẩm</h2>
            <p>Các loại gỗ chất lượng cao chúng tôi cung cấp</p>
          </div>
          
          <div className="grid grid-3">
            <div className="card">
              <img src={image2} alt="Gỗ thông Coffa" style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ thông Coffa</h4>
              <p>Gỗ thông Coffa nhập khẩu chất lượng cao, màu sắc tự nhiên, vân gỗ đẹp mắt, phù hợp cho sản xuất đồ nội thất.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Xuất xứ:</strong> Mỹ, Canada, Châu Âu<br />
                <strong>Đặc điểm:</strong> Mềm mại, bền bỉ, kháng khuẩn
              </div>
            </div>
            
            <div className="card">
              <img src={image3} alt="Gỗ thông sấy" style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ thông sấy</h4>
              <p>Gỗ thông đã qua quá trình sấy khô kỹ lưỡng, đảm bảo độ bền và chất lượng ổn định, ít bị cong vênh.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Ưu điểm:</strong> Chống ẩm tốt, ít cong vênh<br />
                <strong>Ứng dụng:</strong> Đồ nội thất, trang trí
              </div>
            </div>
            
            <div className="card">
              <img src={image4} alt="Gỗ tròn nhập khẩu" style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '5px', marginBottom: '1rem' }} />
              <h4>Gỗ tròn nhập khẩu</h4>
              <p>Gỗ thông tròn hoặc hộp nhập khẩu, đa dạng kích thước, phục vụ nhu cầu khác nhau của khách hàng.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Kích thước:</strong> Đa dạng theo yêu cầu<br />
                <strong>Chất lượng:</strong> Đạt tiêu chuẩn quốc tế
              </div>
            </div>
            
            <div className="card">
              <h4>Gỗ xây dựng</h4>
              <p>Các loại gỗ xây dựng chất lượng cao, phù hợp cho các công trình xây dựng và kiến trúc.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Ứng dụng:</strong> Xây dựng, kiến trúc<br />
                <strong>Độ bền:</strong> Cao, chịu lực tốt
              </div>
            </div>
            
            <div className="card">
              <h4>Gỗ gia công</h4>
              <p>Dịch vụ cưa xẻ gỗ gia công theo quy cách với độ chính xác cao và thiết bị hiện đại.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Độ chính xác:</strong> Cao theo yêu cầu<br />
                <strong>Thời gian:</strong> Nhanh chóng, đúng hẹn
              </div>
            </div>
            
            <div className="card">
              <h4>Dịch vụ vận chuyển</h4>
              <p>Dịch vụ cẩu và vận chuyển gỗ, thiết bị nặng với đội ngũ lái xe chuyên nghiệp.</p>
              <div style={{ marginTop: '1rem' }}>
                <strong>Kinh nghiệm:</strong> 10+ năm<br />
                <strong>An toàn:</strong> Tuyệt đối
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Wood Knowledge */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>Kiến thức về gỗ</h2>
            <p>Những thông tin hữu ích về gỗ và cách tính toán</p>
          </div>
          
          <div className="grid grid-2">
            <div className="card">
              <h4>Cách tính khối gỗ tròn</h4>
              <p>Gỗ tròn (Log) là loại gỗ có hình trụ, thon dài đã loại bỏ các cành, được khai thác từ các cây gỗ đứng.</p>
              <p><strong>Công thức cơ bản:</strong></p>
              <p style={{ 
                backgroundColor: 'var(--bg-light)', 
                padding: '1rem', 
                borderRadius: '5px',
                fontFamily: 'monospace',
                textAlign: 'center'
              }}>
                V = L × S
              </p>
              <p>Trong đó: V là thể tích, L là chiều dài, S là diện tích mặt cắt trung bình.</p>
            </div>
            
            <div className="card">
              <h4>Ưu điểm của gỗ thông xẻ</h4>
              <ul>
                <li>Mềm mại nhưng chắc chắn và dẻo dai</li>
                <li>Khả năng kháng khuẩn và chống ẩm tốt</li>
                <li>Màu gỗ sáng, vân gỗ đẹp mắt</li>
                <li>Tính đàn hồi cao, ít bị cong vênh</li>
                <li>Khả năng bám ốc vít, đinh tốt</li>
                <li>Dễ đánh bóng, nhuộm màu</li>
                <li>Chất gỗ nhẹ, dễ di chuyển</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section bg-light">
        <div className="container text-center">
          <h2>Liên hệ để được tư vấn chi tiết</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>
            Chúng tôi sẵn sàng tư vấn và báo giá chính xác cho từng loại sản phẩm và dịch vụ
          </p>
          <div style={{ marginBottom: '2rem' }}>
            <p><strong>Hotline:</strong> 0915 444 447 (anh Kiên) | 0906 838 171 (cô Nhung)</p>
            <p><strong>📧 Email:</strong> ducphatdatco@gmail.com</p>
          </div>
          <a href="/contact" className="btn btn-primary">
            Liên hệ ngay
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
